import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Box } from 'components/ui/Box';
import ProjectButtonByCondition from './ProjectButtonByCondition';
import Compensation from './Compensation';
import Location from './Location';
import ProjectCompany from './ProjectCompany';
import ProjectTitle from './ProjectTitle';
import ProjectSave from './ProjectSave';

const ProjectCard = ({
  isProjectSaveEnabled,
  onProjectSave,
  onProjectView,
  project,
}) => {
  return (
    <Box
      data-testid="project-card"
      highlight={project.is_match}
      className="mt-3 p-4 d-block d-sm-flex justify-content-between"
    >
      <div className="project-left w-100">
        <ProjectTitle project={project} onProjectView={onProjectView} />
        <Row className="font-sm">
          <Col className="col-sm-4 col-6">
            <Compensation
              compensation={project.marketplace_compensation}
              isFullTime={project.full_time}
              projectType={project.employment_status_human_readable}
            />
          </Col>
          <Col>
            <Location location={project.location} />
            <ProjectCompany
              briefDescription={project.employer_brief_description}
            />
          </Col>
        </Row>
      </div>
      <div className="project-right pt-4 pt-sm-0 d-flex align-items-start">
        <div className="d-flex align-items-center flex-grow-1">
          {isProjectSaveEnabled && (
            <ProjectSave
              className="mr-2 rounded-0"
              iconOnly
              onProjectSave={onProjectSave}
              projectId={project.id}
              projectPin={project.pin}
            />
          )}
          <ProjectButtonByCondition
            data-testid="projectButton"
            id="projectButton"
            onProjectView={onProjectView}
            slug={project.slug}
            talentBidStatus={project.talent_bid_status}
          />
        </div>
      </div>
    </Box>
  );
};

ProjectCard.propTypes = {
  isProjectSaveEnabled: PropTypes.bool,
  onProjectSave: PropTypes.func,
  onProjectView: PropTypes.func,
  project: PropTypes.object.isRequired,
};

ProjectCard.defaultProps = {
  isProjectSaveEnabled: false,
};

export default ProjectCard;
